/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DigestionPart } from "./DigestionPart";
import {
  DigestionPartFromJSON,
  DigestionPartFromJSONTyped,
  DigestionPartToJSON,
} from "./DigestionPart";

export interface DigestionPartListResponse {
  offset: number;
  limit: number;
  order: string;
  sort: string;
  count: number;
  data: Array<DigestionPart>;
}

export function DigestionPartListResponseFromJSON(
  json: any,
): DigestionPartListResponse {
  return DigestionPartListResponseFromJSONTyped(json);
}

export function DigestionPartListResponseFromJSONTyped(
  json: any,
): DigestionPartListResponse {
  if (json == null) {
    return json;
  }

  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(DigestionPartFromJSON),
  };
}

export function DigestionPartListResponseToJSON(
  value: DigestionPartListResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(DigestionPartToJSON),
  };
}
